import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, json, useLocation, useNavigate, useNavigationType } from "react-router-dom";
import NetaqInput from "../components/NetaqInput";
import ActionButton from "../components/ActionButton";
import { useDispatch, useSelector } from "react-redux";
import axiosUmbraco from "../axios/axiosUmbraco";
import {
  FetchChangePasswordthunk,
  FetchCitiesthunk,
  FetchCreateHorseMarketthunk,
  FetchOwnerHorseMarketthunk,
  FetchOwnerHorsesDropDownthunk,
  FetchOwnerHorsesthunk,
  FetchUpdateHorseMarketthunk,
  FetchUpdateOwnerAppuserAccountthunk,
} from "../Redux/OwnerProfile/OwnerProfileAction";
import {
  emptyPage,
  incrementPage,
  resetSearch,
  resetToasterMessage,
} from "../Redux/OwnerProfile/OwnerProfileSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import HorseCard from "../components/HorseCard";
import {
  emptyPageShowEntry,
  handelActiveTabOwnerProfile,
  handelResetShowEntryTempData,
  incrementPageShowEntry,
  resetSearchShowEntry,
} from "../Redux/ShowEntry/ShowEntrySlice";
import {
  FetchShowEntrythunk,
} from "../Redux/ShowEntry/ShowEntryAction";
import { formatDate } from "../helper/formatDate";
import {
  FetchAuctionEntrythunk
} from "../Redux/AuctionEntry/AuctionEntryAction";
import UpgradeProfile from "../components/UpgradeProfile";
import { convertToCamelCase } from "../helper/convertToCamelCase";
import {
  FetchAddFollowUpthunk,
  FetchConfirmImportDatethunk,
  FetchConfirmReceivedHorseDatethunk,
  FetchDeleteOwnerShipTransferServicesRequeststhunk,
  FetchGetAllServicesRequeststhunk,
  FetchGetFollowUpDatathunk,
} from "../Redux/ServicesRequests/ServicesRequestsAction";
import { resetToasterMessageServicesRequests } from "../Redux/ServicesRequests/ServicesRequestsSlice";
import PaymentHistory from "../components/PaymentHistory";
import OrginizingRequests from "../components/OrginizingRequests";
import ParticipateHistory from "../components/ParticipateHistory";
import ScoringTab from "../components/ScoringTab";
import ShowEntryCard from "../components/ShowEntryCard";
import WonHorses from "../components/WonHorses";
import AccountSetting from "../components/AccountSetting";
import EahsForm from "../components/EahsForm";
import FollowUpData from "../components/FollowUpData";
import SearchBox from "../components/SearchBox";
import dayjs from "dayjs";
import { checkIsReturning, consumeReturnTicket, setReturnTicket } from "../helper/pageFilterPersistence";
import { eformCheckBox, eformInput, serviceRequestHeadContainer, serviceRequestTitle, userDropDown } from "../common/cssclasses";
import NewActionButton from "../components/ActionButtons/NewActionButton";
import ServiceFeedBack from "../components/ServiceFeedBack";
import CustomPopUp from "../components/CustomPopUp";
import AuctionEntryList from "./AuctionEntry/AuctionEntryList/AuctionEntryList";
import HandlerShowList from "./HandlerShows/HandlerShowList";
import AccessPermisions from "../components/AccessPermisions";
import UserCentralDropDown from "../components/shared/UserCentralDropDown";
import OldHorsesDialog from "../components/OldHorsesDialog";
import CustomSecondPopUp from "../components/CustomSecondPopUp";
import HorsesAboveThirty from "../components/HorsesAboveThirty";
import { getAllOldHorsesForOwner } from "./sharedAPI/userApis";
import { formatDateTimeToString } from "../helper/formatDateTimeToString";
import SemenRequestsPage from "./seminMarket/Pages/SemenRequestsPage";
import AllServicesRequestsPage from "./services/Pages/AllServicesRequestsPage";

export default function OwnerProfile() {
  const { translate } = useTranslate();
  // const IsTestApp = process.env.REACT_APP_IS_TEST == 'true';
  const isLoggedInUser = localStorage.getItem('currentSubAccountId') === localStorage.getItem('EAHSUserID');

  const BaseURL = process.env.REACT_APP_BASE_URL;
  const REACT_APP_UMBRACO = process.env.REACT_APP_UMBRACO;
  const BaseURLBackEnd = process.env.REACT_APP_BACKEND_API;
  const isTestApp = process.env.REACT_APP_IS_TEST;
  // const BaseURLBackEnd = process.env.REACT_APP_Local_UMBRACO;
  const [addNewHorse, setAddNewHorse] = useState(false);
  const [showHorsesPop, setShowHorsesPop] = useState(false);
  const [searchValue, setSearchValue] = useState(() => sessionStorage.getItem("ownerProfileSearchValue") || "");
  const [selectedSearchType, setSelectedSearchType] = useState(() => sessionStorage.getItem("ownerProfileSearchType") || "-1");
  const userIsUAEPass = localStorage.getItem("EAHSUserIsUAEPASSUser");
  const [userProfile, setUserProfile] = useState("null");
  const [searchShow, setSearchShow] = useState("");
  const [oldHorses, setOldHorses] = useState([]);


  const jsonString = localStorage.getItem("eahsUserProfile") ?? false;
  const cachedUserProfile = jsonString == false ? false : JSON.parse(jsonString)

  const loadDataFromLocal = () => {
    const jsonString = localStorage.getItem("eahsUserProfile");
    if (jsonString) {
      const data = JSON.parse(jsonString);
      setUserProfile(data);
      setSubOwnerProfiles(data.subAccounts);
    }
  };

  useEffect(() => {
    // Function to retrieve JSON data from local storage

    // Call the function to load data when the component mounts
    loadDataFromLocal();
  }, []);
  // console.log("useeeeeeeeeer UAE pass is", userIsUAEPass);

  //Form Account Settings
  const [englishName, setEnglishName] = useState("");
  const [arabicName, setArabicName] = useState("");
  const [email, setEmail] = useState("");
  const [bankName, setBankName] = useState(cachedUserProfile == false ? "" : cachedUserProfile.bankName);
  const [iban, setIban] = useState(cachedUserProfile == false ? "" : cachedUserProfile.iban);
  const [swiftCode, setSwiftCode] = useState(cachedUserProfile == false ? "" : cachedUserProfile.swiftCode);
  const [bneficiaryName, setBneficiaryName] = useState(cachedUserProfile == false ? "" : cachedUserProfile.bneficiaryName);
  const [bankAccountNumber, setBankAccountNumber] = useState(cachedUserProfile == false ? "" : cachedUserProfile.bankAccountNumber);


  const [isAgent, setIsAgent] = useState(cachedUserProfile == false ? "" : cachedUserProfile?.isAgent ?? false);
  const [isHandler, setIsHandler] = useState(cachedUserProfile == false ? "" : cachedUserProfile?.isHandler ?? false);
  const [bankCountry, setBankCountry] = useState({
    text: translate("web.chooseBankCountry", "Choose Bank Country"),
    label: translate("web.chooseBankCountry", "Choose Bank Country"),
    value: null,
  });
  const [curency, setCurency] = useState({
    text: translate("web.curency", "Curency"),
    label: translate("web.curency", "Curency"),
    value: null,
  });

  const [secondEmail, setSecondEmail] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [ownerPhoneNo, setOwnerPhoneNo] = useState("");
  const [smsPhoneNo, setSmsPhoneNo] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [subOwnerProfiles, setSubOwnerProfiles] = useState([]);

  const [signature, setSignature] = useState(null);
  const [emailNotValidMsg, setEmailNotValidMsg] = useState("classnotdisplay");
  const [urlVideoNotValidMsg, setUrlVideoNotValidMsg] =
    useState("classnotdisplay");

  const {
    ownerHorsesData,
    ownerHorsesDropDownData,
    ownerProfileLoading,
    ownerProfileError,
    stateShowMoreButtonHorse,
    page,
    take,
    totalCountOwnerHorses,
    ownerDetailsData,
    citiesData,
    horseDataByRegisterNumberData,
    ownerHorseMarketData,

    detailedResponseCode,
    responseCode,
    toasterMessage,
    ownerAppuserByIdData,
  } = useSelector((state) => state.ownerProfileSlice);

  const { currentLanguage } = useSelector((state) => state.studBookSlice);
  const {
    servicesRequestsLoading,
    getAllServicesRequestsData,
    toasterMessageServicesRequests,
    followUpData,
  } = useSelector((state) => state.servicesRequestsSlice);
  const {
    pageShowEntry,
    takeShowEntry,
    showEntryData,
    showEntryLoading,
    totalCountShowEntry,
  } = useSelector((state) => state.showEntrySlice);
  const { auctionEntryData, auctionEntryLoading, auctionEntryError } =
    useSelector((state) => state.auctionEntrySlice);




  const [searchAuction, setSearchAuction] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  //End table Pagination

  //Location
  const location = useLocation();
  const navigationType = useNavigationType();
  const prevLocationKey = useRef(location.key);
  const isInitialMount = useRef(true);
  const wasReturningRef = useRef(false);

  if (isInitialMount.current) {
    isInitialMount.current = false;
    const isReturning = checkIsReturning("owner_profile_return_ticket", navigationType, "profile");
    wasReturningRef.current = isReturning;
    if (!isReturning) {
      sessionStorage.removeItem("ownerProfileSearchValue");
      sessionStorage.removeItem("ownerProfileSearchType");
      // Don't reset state here as it's already initialized, just clearing the storage for next loads
    }
  }

  useEffect(() => {
    if (wasReturningRef.current) {
      consumeReturnTicket("owner_profile_return_ticket");
    }
  }, []);

  useEffect(() => {
    if (prevLocationKey.current !== location.key) {
      prevLocationKey.current = location.key;
      if (navigationType === "PUSH") {
        sessionStorage.removeItem("ownerProfileSearchValue");
        sessionStorage.removeItem("ownerProfileSearchType");
        setSearchValue("");
        setSelectedSearchType("-1");
      }
    }
  }, [location.key, navigationType]);

  const searchParams = new URLSearchParams(location.search);

  const _activeTab = searchParams.has("activeTab")
    ? searchParams.get("activeTab")
    : null;

  const serviceId = searchParams.has("serviceId")
    ? searchParams.get("serviceId")
    : false;

  const [showPopUp, setShowPopUp] = useState(!!serviceId);


  const [activeTab, setActiveTab] = useState(
    _activeTab != null ? _activeTab : "accountSetting"
  );
  const [isOwnedHorsesOpen, setIsOwnedHorsesOpen] = useState(
    _activeTab === "allRegisteredHorses" ||
    _activeTab === "exported" ||
    _activeTab === "dead" ||
    _activeTab === "inactive"
  );
  const [isEventEntryOpen, setIsEventEntryOpen] = useState(
    _activeTab === "showEntry" ||
    _activeTab === "auctionEntry" ||
    _activeTab === "participateHistory" ||
    _activeTab === "wonhorses" ||
    _activeTab === "handlerShow"
  );
  const [isMyOrdersOpen, setIsMyOrdersOpen] = useState(
    _activeTab === "e_services" ||
    _activeTab === "semenRequests" ||
    _activeTab === "paymentHistory" ||
    _activeTab === "organizerRequests"
  );
  const [isMyProfileOpen, setIsMyProfileOpen] = useState(
    _activeTab === "accountSetting" ||
    _activeTab === "teamsAccessPermissions" ||
    _activeTab == null
  );
  const [showHandlerCompetition, setShowHandlerCompetition] = useState(false);
  const [openCategory, setOpenCategory] = useState(null);
  const [dropdownStyle, setDropdownStyle] = useState({});
  const mobileNavRef = useRef(null);
  const buttonRefs = useRef({});

  useEffect(() => {
    function handleClickOutside(event) {
      if (mobileNavRef.current && !mobileNavRef.current.contains(event.target)) {
        setOpenCategory(null);
      }
    }
    if (openCategory) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [openCategory]);

  useEffect(() => {
    async function getUmbracoSettings() {
      try {
        const FooterID = process.env.REACT_APP_HOME_PAGE_FOOTER_ID;
        const lang = localStorage.getItem("eahsLang") ?? "en";
        const umbracoLang = lang === "en" ? 'en-US' : 'ar-AE';
        const res = await axiosUmbraco.get(`/umbraco/delivery/api/v1/content/item?id=${FooterID}`, {
          headers: {
            "accept-language": umbracoLang,
          }
        });
        if (res.data && res.data.length > 0) {
          setShowHandlerCompetition(
            userProfile.accountType != "Organizer" && userProfile.accountType != "Scoring"
            (res.data[0]?.properties?.showHandlerCompetition ?? false));
        }
      } catch (error) {
        console.error("Error fetching umbraco settings", error);
      }
    }
    getUmbracoSettings();
  }, []);
  const setActiveTabQuery = (tab) => {

    searchParams.set("activeTab", tab); // Set the search parameter
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.pushState({}, '', newUrl); // Update the URL without reloading the page
  };


  function renderSelectedAccount() {
    const loggedinId = localStorage.getItem("EAHSUserID");
    const selectedId = localStorage.getItem("currentSubAccountId");
    let uiSelectedObg = {};
    if (loggedinId == selectedId) {
      uiSelectedObg = {
        label:
          currentLanguage == "en"
            ? JSON.parse(localStorage.getItem("eahsUserProfile"))?.ownerRegisterNo +
            " - " +
            JSON.parse(localStorage.getItem("eahsUserProfile"))?.fullName
            : JSON.parse(localStorage.getItem("eahsUserProfile"))?.ownerRegisterNo +
            " - " +
            JSON.parse(localStorage.getItem("eahsUserProfile"))?.fullNameAr,
        value: localStorage.getItem("EAHSUserID"),
        text:
          currentLanguage == "en"
            ? JSON.parse(localStorage.getItem("eahsUserProfile"))?.ownerRegisterNo +
            " - " +
            JSON.parse(localStorage.getItem("eahsUserProfile"))?.fullName
            : JSON.parse(localStorage.getItem("eahsUserProfile"))?.ownerRegisterNo +
            " - " +
            JSON.parse(localStorage.getItem("eahsUserProfile"))?.fullNameAr,
      }
    } else if (loggedinId != selectedId) {

      const selectedSubAccount = JSON.parse(localStorage.getItem("eahsUserProfile")).subAccounts.find((x) => x.value == selectedId);

      uiSelectedObg = {
        label:
          currentLanguage == "en"
            ? selectedSubAccount?.registerNo +
            " - " +
            selectedSubAccount?.text
            : selectedSubAccount?.registerNo +
            " - " +
            selectedSubAccount?.textAr,
        text:
          currentLanguage == "en"
            ? selectedSubAccount?.registerNo +
            " - " +
            selectedSubAccount?.text
            : selectedSubAccount?.registerNo +
            " - " +
            selectedSubAccount?.textAr,
        value: selectedId,
      }
    }
    return uiSelectedObg;
  }


  const [profile, setProfile] = useState(renderSelectedAccount());

  const [subAccountsLoaded, setSubAccountsLoaded] = useState(false);

  const [uploadedHandlerCertificate, setUploadedHandlerCertificate] = useState([]);
  const [uploadedNationalIdFile, setUploadedNationalIdFile] = useState([]);
  const [profileImageFile, setProfileImageFile] = useState([]);
  const [hasTrn, setHasTrn] = useState(null);
  const [trn, setTrn] = useState([]);
  const [trcFile, setTrcFile] = useState([]);
  const handleHandlerCertificateUploaded = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      let checkFileSize = true;
      const fileListHook = [];

      for (let fileIndex = 0; fileIndex < e.target.files.length; fileIndex++) {
        if (e.target.files[fileIndex].size > 10 * 1024 * 1024) {
          checkFileSize = false;
          toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
        } else {
          // Check allowed file types
          const file = e.target.files[fileIndex];
          const allowedMimeTypes = ['image/', 'application/pdf'];

          if (!allowedMimeTypes.some(type => file.type.startsWith(type))) {
            toast.error(translate("web.invalidFileType", "Only images and PDFs allowed."));
            continue; // Skip to the next file if type is not allowed
          }

          fileListHook.push({
            documentFile: URL.createObjectURL(e.target.files[fileIndex]),
            name: e.target.files[fileIndex].name,
            file: e.target.files[fileIndex],
          });
        }
      }

      setUploadedHandlerCertificate(fileListHook);
    }
  };

  const handleNationalIdFileUploaded = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      let checkFileSize = true;
      const fileListHook = [];

      for (let fileIndex = 0; fileIndex < e.target.files.length; fileIndex++) {
        if (e.target.files[fileIndex].size > 10 * 1024 * 1024) {
          checkFileSize = false;
          toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
        } else {
          // Check allowed file types
          const file = e.target.files[fileIndex];
          const allowedMimeTypes = ['image/', 'application/pdf'];

          if (!allowedMimeTypes.some(type => file.type.startsWith(type))) {
            toast.error(translate("web.invalidFileType", "Only images and PDFs allowed."));
            continue; // Skip to the next file if type is not allowed
          }

          fileListHook.push({
            documentFile: URL.createObjectURL(e.target.files[fileIndex]),
            name: e.target.files[fileIndex].name,
            file: e.target.files[fileIndex],
          });
        }
      }

      setUploadedNationalIdFile(fileListHook);
    }
  };
  const handleProfileImageFileUploaded = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      let checkFileSize = true;
      const fileListHook = [];

      for (let fileIndex = 0; fileIndex < e.target.files.length; fileIndex++) {
        if (e.target.files[fileIndex].size > 10 * 1024 * 1024) {
          checkFileSize = false;
          toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
        } else {
          // Check allowed file types
          const file = e.target.files[fileIndex];
          const allowedMimeTypes = ['image/'];

          if (!allowedMimeTypes.some(type => file.type.startsWith(type))) {
            toast.error(translate("web.invalidFileType", "Only images and PDFs allowed."));
            continue; // Skip to the next file if type is not allowed
          }

          fileListHook.push({
            documentFile: URL.createObjectURL(e.target.files[fileIndex]),
            name: e.target.files[fileIndex].name,
            file: e.target.files[fileIndex],
          });
        }
      }

      setProfileImageFile(fileListHook);
    }
  };

  useEffect(() => {
    if (subAccountsLoaded == false && userProfile.accountType == "Agent") {
      if (subOwnerProfiles.length > 0) {
        setProfile({
          label: subOwnerProfiles[0].text,
          value: subOwnerProfiles[0].value,
          text: subOwnerProfiles[0].text,
        });
        setSubAccountsLoaded(true);
      }
    }
  }, [subOwnerProfiles]);

  const dispatch = useDispatch();

  const [hovered, setHovered] = useState({
    sign: false,
    close: false,
    clear: false,
    save: false,
    secondsignature: false,
  });

  const [imageURL, setImageURL] = useState(null);
  const [urlImages, setUrlImages] = useState([]);

  const [newHorseModel, setNewHorseModel] = useState({
    id: "",
    selectDrop: {
      label: translate("web.registerationNumber", "Registeration Number"),
      value: "",
    },
    regNo: "",
    nameEn: "",
    nameAr: "",
    category: "",
    categoryDrop: {
      label: translate("web.category", "category"),
      value: "",
    },
    price: "",
    city: "",
    cityDrop: {
      label: translate("web.emirate", "Emirate"),
      value: "",
    },
    address: "",
    phone: "",
    email: "",
    urlVideo: "",
    horseId: "",
    type: "",
    typeDrop: {
      label: translate("web.type", "type"),
      value: "",
    },
    isSold: false,
  });

  const [files, setFiles] = useState([]);
  const [emptyFiles, setEmptyFiles] = useState(true);
  const [showErrorConfirmPassword, setShowErrorConfirmPassword] =
    useState("none");



  const handleMouseOver = (type) => {
    setHovered((prev) => ({ ...prev, [type]: true }));
  };

  const handleMouseOut = (type) => {
    setHovered((prev) => ({ ...prev, [type]: false }));
  };

  const generateButtonStyle = (isHovered) => ({
    background: !isHovered ? "#ffffff" : "var(--mainGold)",
    padding: "10px 20px",
    color: !isHovered ? "var(--mainGold)" : "#fff",
    outline: 0,
    border: "solid",
    borderWidth: 1,
    borderColor: "var(--mainGold)",
    transition: "all 0.3s",
    display: "block",
    cursor: "pointer",
    textTransform: "uppercase",
    fontSize: "12px",
    fontWeight: "bold",
  });

  const buttonSubmitStyle = generateButtonStyle(hovered.sign);
  const buttonclearStyle = generateButtonStyle(hovered.clear);
  const buttoncloseStyle = generateButtonStyle(hovered.close);



  useEffect(() => {
    // dispatch(FetchOwnerAppuserByIdthunk(localStorage.getItem("EAHSUserID")));
    let params = {
      ownerId: localStorage.getItem("currentSubAccountId"),
      skip: 0,
      take,
      langauge: currentLanguage,
      horseTypeFilter: "1",
      searchValue: searchValue,
      sortBy: selectedSearchType,
    };
    dispatch(FetchOwnerHorsesthunk(params));
  }, []);

  useEffect(() => {
    dispatch(handelActiveTabOwnerProfile("allRegisteredHorses"));
    dispatch(handelResetShowEntryTempData());
    if (
      activeTab === "allRegisteredHorses" ||
      activeTab === "exported" ||
      activeTab === "dead" ||
      activeTab === "inactive"
    ) {
      if (page === 0) {
        dispatch(resetSearch());
        return;
      }
      let horse_type_filter;

      if (activeTab === "allRegisteredHorses") {
        horse_type_filter = "1";
      } else if (activeTab === "exported") {
        horse_type_filter = "2";
      } else if (activeTab === "dead") {
        horse_type_filter = "3";
      } else if (activeTab === "inactive") {
        horse_type_filter = "4";
      }
      if (userProfile.accountType != "BasicAccount") {
        let params = {
          ownerId: localStorage.getItem("currentSubAccountId"),
          skip: (page - 1) * take,
          take,
          langauge: currentLanguage,
          horseTypeFilter: horse_type_filter,
          searchValue: searchValue,
          sortBy: selectedSearchType,
        };
        dispatch(FetchOwnerHorsesthunk(params));
      }
    } else if (activeTab === "accountSetting") {
      let params = {
        ownerId: localStorage.getItem("currentSubAccountId"),
        skip: 0,
        take,
        langauge: currentLanguage,
        horseTypeFilter: "1",
        searchValue: searchValue,
        sortBy: selectedSearchType,
      };
      dispatch(FetchOwnerHorsesthunk(params));

      // dispatch(FetchOwnerAppuserByIdthunk(localStorage.getItem("EAHSUserID")));
    } else if (activeTab === "horseMarket") {
      handleHorseMarketReset();
      setAddNewHorse(false);
      dispatch(FetchCitiesthunk());
      dispatch(
        FetchOwnerHorseMarketthunk(localStorage.getItem("currentSubAccountId"))
      );
      let params = {
        ownerId: localStorage.getItem("currentSubAccountId"),
        skip: 0,
        take: 1000,
        langauge: currentLanguage,
        horseTypeFilter: "1",
        searchValue: "",
        sortBy: "-1",
      };
      dispatch(FetchOwnerHorsesDropDownthunk(params));
    } else if (activeTab === "showEntry") {
      if (pageShowEntry === 0) {
        dispatch(resetSearchShowEntry());
        return;
      }
      if (userProfile.accountType != "BasicAccount") {
        let params = {
          ownerId: localStorage.getItem("currentSubAccountId"),
          skip: (pageShowEntry - 1) * takeShowEntry,
          take: takeShowEntry,
          langauge: currentLanguage,
        };
        dispatch(FetchShowEntrythunk(params));
      }
    } else if (activeTab === "auctionEntry") {
      let params = {
        langauge: currentLanguage,
        ownerId: localStorage.getItem("currentSubAccountId"),
      };
      dispatch(FetchAuctionEntrythunk(params));
    }

  }, [page, pageShowEntry, currentLanguage, activeTab, smsPhoneNo]);

  const handelShowMore = async () => {
    dispatch(incrementPage());
  };

  const inputRef = useRef(null);
  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };



  const regNoRef = useRef("");
  useEffect(() => {
    if (Object.keys(horseDataByRegisterNumberData).length !== 0) {
      setNewHorseModel({
        ...newHorseModel,
        regNo: regNoRef.current,
        horseId: horseDataByRegisterNumberData.id,
        nameAr: horseDataByRegisterNumberData.nameAr,
        nameEn: horseDataByRegisterNumberData.nameEn,
        address:
          currentLanguage === "en"
            ? horseDataByRegisterNumberData.address
            : horseDataByRegisterNumberData.addressAr,
      });
    }
  }, [horseDataByRegisterNumberData]);

  const handleChange = (e) => {
    setSearchValue(e.target.value);
    sessionStorage.setItem("ownerProfileSearchValue", e.target.value);
    // dispatch(resetSearch());
  };

  const handleSelectedSearchType = (e) => {
    setSelectedSearchType(e?.value);
    sessionStorage.setItem("ownerProfileSearchType", e?.value || "-1");
    // dispatch(resetSearch());
  };

  const handelSearch = async () => {
    dispatch(emptyPage());
  };

  const handleFileChange = (e) => {
    let checkFileSize = true;
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].size > 10 * 1024 * 1024) {
        checkFileSize = false;
      } else {
        if (e.target.files && e.target.files.length > 0) {
          setSignature(e.target.files[0]);

          var reader = new FileReader();
          reader.readAsDataURL(e.target.files[0]);
          reader.onload = function () {
            setImageURL(reader.result);
          };
        }
      }
    }

    if (!checkFileSize) {
      toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
    }
  };

  const handelUpdateOwnerAppuserAccount = async (e) => {
    e.preventDefault();
    let params = {
      id: localStorage.getItem("EAHSUserID"),
      secondMobileNo:
        mobileNo === "" ? ownerAppuserByIdData.secondMobileNo : mobileNo,
      phoneNo:
        ownerPhoneNo === "" ? ownerAppuserByIdData.phoneNo : ownerPhoneNo,
      secondEmail:
        secondEmail === "" ? ownerAppuserByIdData.secondEmail : secondEmail,

      email: email === "" ? ownerAppuserByIdData.email : email,
      mobileNo: phoneNo === "" ? ownerAppuserByIdData.mobileNo : phoneNo,

      signature: imageURL !== null ? imageURL : ownerAppuserByIdData.signature,
      tableType:
        userProfile.accountType != "BasicAccount" && userIsUAEPass === "false"
          ? "AppUserAndOwner"
          : userProfile.accountType != "BasicAccount" &&
            userIsUAEPass === "true"
            ? "Owner"
            : !userProfile.accountType != "BasicAccount" &&
              userIsUAEPass === "false"
              ? "AppUser"
              : "",
      bankName: bankName,
      iban: iban,
      swiftCode: swiftCode,
      bneficiaryName: bneficiaryName,
      bankCountryId: bankCountry?.value,
      currencyId: curency?.value,
      bankAccountNumber: bankAccountNumber,
      isAgent: isAgent,
      isHandler: isHandler,
      handlerFile: uploadedHandlerCertificate[0]?.file ?? null,
      nationalIdFile: uploadedNationalIdFile[0]?.file ?? null,
      ProfileImageFile: profileImageFile.length > 0 ? profileImageFile[0]?.file : null,
      TrcFile: trcFile.length > 0 ? trcFile[0]?.file : null,
      Trn: trn ?? '',
      HasTrn: hasTrn ?? null,

    };

    dispatch(FetchUpdateOwnerAppuserAccountthunk(params));
  };

  const handelChangePassword = async (e) => {
    e.preventDefault();
    if (confirmPassword === confirmNewPassword) {
      let params = {
        userId: localStorage.getItem("currentSubAccountId"),
        //userId: "5FE062BC-4B73-4A7B-B498-017CD4BA2CFC",
        currentPassword: oldPassword,
        newPassword: confirmNewPassword,
      };
      setShowErrorConfirmPassword("none");

      dispatch(FetchChangePasswordthunk(params));
    } else {
      setShowErrorConfirmPassword("block");
    }
  };

  const handleHorseMarketReset = () => {
    setNewHorseModel({
      ...newHorseModel,
      id: "",
      regNo: "",
      selectDrop: {
        label: translate("web.registerationNumber", "Registeration Number"),
        value: "",
      },
      nameEn: "",
      nameAr: "",
      category: "",
      price: "",
      city: "",
      address: "",
      phone: ownerDetailsData.phone,
      email: ownerDetailsData.email,
      urlVideo: "",
      horseId: "",
      type: "",
      isSold: false,
    });

    setFiles([]);
    setUrlImages([]);
    setEmptyFiles(false);
    regNoRef.current = "";
  };

  function validateEmail(email) {
    const pattern =
      /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,9}[\.][a-z]{2,5}/g;
    return pattern.test(newHorseModel.email);
  }

  function validUrl(urlVideo) {
    const validate = urlVideo.includes("http") || urlVideo.includes("https");
    // const regex =
    //   /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm;
    return validate;
  }

  const handelNewHorse = async () => {
    if (validateEmail(newHorseModel.email) === false) {
      setEmailNotValidMsg("classdisplay");
      return;
    }

    if (
      newHorseModel.urlVideo !== "" &&
      validUrl(newHorseModel.urlVideo) === false
    ) {
      setUrlVideoNotValidMsg("classdisplay");
      return;
    }

    if (
      ownerHorseMarketData.find(
        (e) => e.horseRegisterNumber === newHorseModel.regNo
      ) &&
      newHorseModel.id === ""
    ) {
      toast.error(
        translate("web.cannotaddhorse", "This horse has been added before")
      );
      return;
    }

    setEmailNotValidMsg("classnotdisplay");
    setUrlVideoNotValidMsg("classnotdisplay");
    if (newHorseModel.id === "") {
      let params = {
        ownerId: localStorage.getItem("currentSubAccountId"),
        //ownerId: "3a5f8ec0-c888-4b2b-4c0c-08dc12faba88",
        horseId: newHorseModel.horseId,
        nameAr: newHorseModel.nameAr,
        nameEn: newHorseModel.nameEn,
        regNo: newHorseModel.regNo,
        category: newHorseModel.category,
        price: newHorseModel.price,
        city: newHorseModel.city,
        address: newHorseModel.address,
        phone: newHorseModel.phone,
        email: newHorseModel.email,
        urlVideo: newHorseModel.urlVideo,
        type: newHorseModel.type,
        files: files,
        //files: signature,
      };

      dispatch(FetchCreateHorseMarketthunk(params));
    } else {
      let imageListObjectsFirst = files.map((x) => ({
        id: "",
        image: x,
        url: "",
      }));
      let imageListObjectsSecond = urlImages.map((x) => ({
        id: "",
        image: null,
        url: x.substring(x.lastIndexOf("/") + 1),
      }));
      let imageListObjects = [
        ...imageListObjectsFirst,
        ...imageListObjectsSecond,
      ];

      let params = {
        horseMarket: {
          id: newHorseModel.id,
          englishName: newHorseModel.nameEn,
          arabicName: newHorseModel.nameAr,
          horsecategory: newHorseModel.category,
          horsePrice: newHorseModel.price,
          cityId: newHorseModel.city,
          address: newHorseModel.address,
          contact: newHorseModel.phone,
          email: newHorseModel.email,
          youTubeVideoUrl: newHorseModel.urlVideo,
          marketType: newHorseModel.type,
          isActive: null,
          isApproved: null,
          isSold: newHorseModel.isSold,
        },
        imageListObjects,
      };

      dispatch(FetchUpdateHorseMarketthunk(params));
    }
    if (!ownerProfileLoading && ownerProfileError === null) {
      handleHorseMarketReset();
      dispatch(
        FetchOwnerHorseMarketthunk(localStorage.getItem("currentSubAccountId"))
      );
    }
  };

  useEffect(() => {
    if (toasterMessage != null && toasterMessage === "save") {
      toast.success(
        translate("web.dataSavedSuccessfully", "Data Saved Successfully")
      );
      dispatch(resetToasterMessage());
    } else if (toasterMessage != null && toasterMessage === "delete") {
      toast.success(translate("web.deleted", "Deleted Success"));
      dispatch(resetToasterMessage());
    } else if (toasterMessage != null && toasterMessage === "update") {
      toast.success(
        translate("web.dataUpdatedSuccessfully", "Data Updated Successfully")
      );
      dispatch(resetToasterMessage());
    } else if (
      toasterMessage != null &&
      toasterMessage === "changepassword" &&
      responseCode === "200"
    ) {
      toast.success(
        translate(
          `web.${convertToCamelCase(detailedResponseCode)}`,
          detailedResponseCode
        )
      );
      dispatch(resetToasterMessage());
    } else if (
      toasterMessage != null &&
      toasterMessage === "changepassword" &&
      responseCode === "100"
    ) {
      toast.error(
        translate(
          `web.${convertToCamelCase(detailedResponseCode)}`,
          detailedResponseCode
        )
      );
      dispatch(resetToasterMessage());
    }
  }, [toasterMessage]);

  const dismissAll = () => toast.dismiss();

  const handelUpdateHorseMarket = (horseMarket) => {
    setAddNewHorse(true);
    setNewHorseModel({
      id: horseMarket.id,
      regNo: horseMarket.horseRegisterNumber,
      selectDrop: {
        label:
          horseMarket.horseRegisterNumber +
          " - " +
          (currentLanguage === "en"
            ? horseMarket.englisName
            : horseMarket.arabicName),
        value: horseMarket.horseRegisterNumber,
      },
      nameEn: horseMarket.englisName,
      nameAr: horseMarket.arabicName,
      category:
        horseMarket.horseCategory === "ShowHorse"
          ? "1"
          : horseMarket.horseCategory === "FlatRace"
            ? "2"
            : horseMarket.horseCategory === "EnduranceHorse"
              ? "3"
              : "",
      price: horseMarket.horsePrice,
      city: horseMarket.cityId,
      address: horseMarket.address,
      phone: horseMarket.phone,
      email: horseMarket.email,
      urlVideo: horseMarket.urlVideo,
      horseId: horseMarket.horseId,
      type: horseMarket.type,
      isSold: horseMarket.isSold,
    });

    let newArray = horseMarket.horseMarketMedia.map((x) => x.url);
    setUrlImages(newArray);
  };

  const handelDeleteServiceRequest = (id) => {
    dispatch(FetchDeleteOwnerShipTransferServicesRequeststhunk(id));
  };


  useEffect(() => {
    if (
      toasterMessageServicesRequests != null &&
      (toasterMessageServicesRequests === "save" || toasterMessageServicesRequests === "saveFollowUp")
    ) {
      dispatch(resetToasterMessageServicesRequests());

      if (toasterMessageServicesRequests === "save") {
        toast.success(
          translate("web.dataSavedSuccessfully", "Data Saved Successfully")
        );

        let params = {
          language: currentLanguage,
          userId: localStorage.getItem("currentSubAccountId"),
        };

        dispatch(FetchGetAllServicesRequeststhunk(params));
      }
      else if (toasterMessageServicesRequests === "saveFollowUp") {
        toast.success(
          translate("web.sendFollowUp", "Message sent successfully")
        );
      }

    }
  }, [toasterMessageServicesRequests]);

  const appUserProfileString = localStorage.getItem("eahsUserProfile") ?? "";

  let appUserProfile = "";
  if (!!appUserProfileString) {
    appUserProfile = JSON.parse(appUserProfileString);
  }

  // useEffect(() => {
  //   localStorage.setItem("currentSubAccountId", profile.value);

  //   dispatch(setCurrentSubAccount());

  //   localStorage.setItem("currentSubAccountLabel", profile.label);
  // }, [profile]);

  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleSelectAccountChange = (e) => {
    setProfile(e);
    // localStorage.setItem('currentSubAccountId', e?.value)
    let params = {
      ownerId: e,
      skip: 0,
      take,
      langauge: currentLanguage,
      horseTypeFilter: "1",
      searchValue: searchValue,
      sortBy: selectedSearchType,
    };
    setShowLoader(true)
    window.location.reload();
    // dispatch(FetchOwnerHorsesthunk(params));
    // setActiveTab("");
    // setActiveTab("allRegisteredHorses");
    // setActiveTabQuery('allRegisteredHorses')
  };

  // upcoming events
  const upcomingEvents = showEntryData
    .filter((item) => {
      if (searchShow === "") {
        return item;
      } else if (searchShow !== "") {
        return item.showName
          .toLowerCase()
          .includes(searchShow.toLowerCase());
      }
    })
    .filter((show) => (show?.isLocalRegistrationOpen || show?.isInternationalRegistrationOpen || show?.isFoalRegistrationOpen));



  const hasOwnedHorsesPermission = (((userProfile.accountType == "LocalOwner" ||
    userProfile.accountType == null) &&
    (userProfile.status == null ||
      !userProfile.status.includes("Pending"))) ||
    userProfile.accountType == "Agent");

  const hasParticipateHistoryPermission =userProfile.accountType != "Organizer" && userProfile.accountType != "Scoring" && (((userProfile.status == null ||
    !userProfile.status.includes("Pending"))) ||
    userProfile.accountType == "InternationalOwner" ||
    (userProfile.accountType == "Agent" &&
      (subOwnerProfiles
        .filter((x) => x.value == profile.value)[0]
        ?.ownersPermissionsList.map((z) => z.permissionName)
        .filter((z) => z == "ShowEntry").length > 0 ||
        subOwnerProfiles
          .filter((x) => x.value == profile.value)[0]
          ?.ownersPermissionsList.map((z) => z.permissionName)
          .includes("All"))));

  const hasShowEntryPermission = (((userProfile.accountType == "LocalOwner" ||
    userProfile.accountType == null) &&
    (userProfile.status == null ||
      !userProfile.status.includes("Pending"))) ||
    userProfile.accountType == "InternationalOwner" ||
    (userProfile.accountType == "Agent" &&
      (subOwnerProfiles
        .filter((x) => x.value == profile.value)[0]
        ?.ownersPermissionsList.map((z) => z.permissionName)
        .filter((z) => z == "ShowEntry").length > 0 ||
        subOwnerProfiles
          .filter((x) => x.value == profile.value)[0]
          ?.ownersPermissionsList.map((z) => z.permissionName)
          .includes("All"))));

  const hasAuctionEntryPermission = (((userProfile.accountType == "LocalOwner" ||
    userProfile.accountType == null) &&
    (userProfile.status == null ||
      !userProfile.status.includes("Pending"))) ||
    (userProfile.accountType == "Agent" &&
      (subOwnerProfiles
        .filter((x) => x.value == profile.value)[0]
        ?.ownersPermissionsList.map((z) => z.permissionName)
        .filter((z) => z == "AuctionEntry").length > 0 ||
        subOwnerProfiles
          .filter((x) => x.value == profile.value)[0]
          ?.ownersPermissionsList.map((z) => z.permissionName)
          .includes("All"))));

  const hasWonHorsesPermission = (((userProfile.accountType == "LocalOwner" ||
    userProfile.accountType == null) &&
    (userProfile.status == null ||
      !userProfile.status.includes("Pending"))) ||
    (userProfile.accountType == "Agent" &&
      (subOwnerProfiles
        .filter((x) => x.value == profile.value)[0]
        ?.ownersPermissionsList.map((z) => z.permissionName)
        .filter((z) => z == "AuctionEntry").length > 0 ||
        subOwnerProfiles
          .filter((x) => x.value == profile.value)[0]
          ?.ownersPermissionsList.map((z) => z.permissionName)
          .includes("All"))));

  const mobileMenuGroups = useMemo(() => {
    const groups = [];

    // 1. Owned Horses
    if (hasOwnedHorsesPermission) {
      groups.push({
        id: "ownedHorses",
        title: translate("web.ownedHorses", "Owned Horses"),
        icon: "fa-folder-open-o",
        items: [
          {
            key: "allRegisteredHorses",
            label: translate("web.allRegisteredHorses", "Registered Horses"),
            onClick: () => {
              dispatch(emptyPage());
              setActiveTab("allRegisteredHorses");
              setActiveTabQuery("allRegisteredHorses");
            },
          },
          {
            key: "exported",
            label: translate("web.exported", "Exported"),
            onClick: () => {
              dispatch(emptyPage());
              setActiveTab("exported");
              setActiveTabQuery("exported");
            },
          },
          {
            key: "dead",
            label: translate("web.dead", "Dead"),
            onClick: () => {
              dispatch(emptyPage());
              setActiveTab("dead");
              setActiveTabQuery("dead");
            },
          },
          {
            key: "inactive",
            label: translate("web.inactive", "Inactive"),
            onClick: () => {
              dispatch(emptyPage());
              setActiveTab("inactive");
              setActiveTabQuery("inactive");
            },
          },
        ],
      });
    }

    // 2. Event Entry
    if (
      hasShowEntryPermission ||
      hasAuctionEntryPermission ||
      hasParticipateHistoryPermission ||
      hasWonHorsesPermission ||
      showHandlerCompetition
    ) {
      const items = [];
      if (hasShowEntryPermission) {
        items.push({
          key: "showEntry",
          label: translate("web.showEntry", "Show Entry"),
          onClick: () => {
            dispatch(emptyPageShowEntry());
            setActiveTab("showEntry");
            setActiveTabQuery("showEntry");
          },
        });
      }
      if (hasAuctionEntryPermission) {
        items.push({
          key: "auctionEntry",
          label: translate("web.auctionEntry", "Auction Entry"),
          onClick: () => {
            setActiveTab("auctionEntry");
            setActiveTabQuery("auctionEntry");
          },
        });
      }
      if (hasParticipateHistoryPermission) {
        items.push({
          key: "participateHistory",
          label: translate("web.participateHistory", "Participate History"),
          onClick: () => {
            setActiveTab("participateHistory");
            setActiveTabQuery("participateHistory");
          },
        });
      }
      if (hasWonHorsesPermission) {
        items.push({
          key: "wonhorses",
          label: translate("web.horsesAcquiredAtAuctions", "Horses Acquired At Auctions"),
          onClick: () => {
            setActiveTab("wonhorses");
            setActiveTabQuery("wonhorses");
          },
        });
      }
      if (showHandlerCompetition) {
        items.push({
          key: "handlerShow",
          label: translate("web.emirateHandlerCompetition", "Emirati Handler competition"),
          onClick: () => {
            setActiveTab("handlerShow");
            setActiveTabQuery("handlerShow");
          },
        });
      }
      if (items.length > 0) {
        groups.push({
          id: "eventEntry",
          title: translate("web.eventEntry", "Event Entry"),
          icon: "fa-trophy",
          items,
        });
      }
    }

    // 3. My Orders
    if (userProfile?.accountType !== "Scoring") {
      const items = [];
      if (userProfile?.accountType !== "Organizer") {
        items.push({
          key: "e_services",
          label: translate("web.servicesRequests", "Services Requests"),
          onClick: () => {
            setActiveTab("e_services");
            setActiveTabQuery("e_services");
          },
        });
        if (isTestApp == "true") {
          items.push({
            key: "semenRequests",
            label: translate("web.semenOrders", "Semen Orders"),
            onClick: () => {
              setActiveTab("semenRequests");
              setActiveTabQuery("semenRequests");
            },
          });
        }
        items.push({
          key: "paymentHistory",
          label: translate("web.paymentHistory", "Payment History"),
          onClick: () => {
            setActiveTab("paymentHistory");
            setActiveTabQuery("paymentHistory");
          },
        });
      }
      if (items.length > 0) {
        groups.push({
          id: "myOrders",
          title: translate("web.myOrders", "My Orders"),
          icon: "fa-shopping-bag",
          items,
        });
      }
    }

      if (userProfile?.accountType === "Organizer") {
        groups.push({
          id: "organizerRequests",
          title: translate("web.organizingRequests", "Organizing Requests"),
        icon: "fa-trophy",
              items: [
          {
          key: "organizerRequests",
          label: translate("web.organizingRequests", "Organizing Requests"),
          onClick: () => {
            setActiveTab("organizerRequests");
            setActiveTabQuery("organizerRequests");
          },
          },
        ],
        });
      }
    // Scoring Account Tab
    if (userProfile?.accountType == "Scoring") {
      groups.push({
        id: "scoring",
        title: translate("web.liveShowResult", "Live Show Result"),
        icon: "fa-star",
        items: [
          {
            key: "liveShowResult",
            label: translate("web.liveShowResult", "Live Show Result"),
            onClick: () => {
              setActiveTab("liveShowResult");
              setActiveTabQuery("liveShowResult");
            },
          },
        ],
      });
    }

    // 4. My Profile
    const profileItems = [
      {
        key: "accountSetting",
        label: translate("web.profileDetails", "Profile Details"),
        onClick: () => {
          setActiveTab("accountSetting");
          setActiveTabQuery("accountSetting");
        },
      },
    ];
    if (isLoggedInUser) {
      profileItems.push({
        key: "teamsAccessPermissions",
        label: translate("web.teamsAccessPermissions", "Teams Access Permissions"),
        onClick: () => {
          setActiveTab("teamsAccessPermissions");
          setActiveTabQuery("teamsAccessPermissions");
        },
      });
    }
    groups.push({
      id: "myProfile",
      title: translate("web.myProfile", "My Profile"),
      icon: "fa-user",
      items: profileItems,
    });

    return groups;
  }, [
    hasOwnedHorsesPermission,
    hasShowEntryPermission,
    hasAuctionEntryPermission,
    hasParticipateHistoryPermission,
    hasWonHorsesPermission,
    showHandlerCompetition,
    userProfile?.accountType,
    isTestApp,
    isLoggedInUser,
    translate,
    dispatch,
    setActiveTabQuery,
  ]);

  const openGroup = useMemo(
    () => mobileMenuGroups.find((g) => g.id === openCategory),
    [mobileMenuGroups, openCategory]
  );

  const isCategoryActive = (group) => {
    return group.items.some((item) => item.key === activeTab);
  };

  const handleCategoryClick = (group) => {
    if (group.items.length === 1) {
      handleMobileTabSelect(group.items[0], group);
      setOpenCategory(null);
      return;
    }

    if (openCategory === group.id) {
      setOpenCategory(null);
      return;
    }

    const navEl = mobileNavRef.current;
    const btnEl = buttonRefs.current[group.id];
    if (navEl && btnEl) {
      const navRect = navEl.getBoundingClientRect();
      const btnRect = btnEl.getBoundingClientRect();
      const top = btnRect.bottom - navRect.top + 6;

      const dropdownWidth = 230;
      if (currentLanguage === "ar") {
        const rightOffset = navRect.right - btnRect.right;
        const maxRight = Math.max(4, Math.min(rightOffset, navRect.width - dropdownWidth));
        setDropdownStyle({
          top: `${top}px`,
          right: `${maxRight}px`,
          left: "auto",
        });
      } else {
        const leftOffset = btnRect.left - navRect.left;
        const maxLeft = Math.max(4, Math.min(leftOffset, navRect.width - dropdownWidth));
        setDropdownStyle({
          top: `${top}px`,
          left: `${maxLeft}px`,
          right: "auto",
        });
      }
    }
    setOpenCategory(group.id);
  };

  const handleMobileTabSelect = (item, group) => {
    if (item.onClick) {
      item.onClick();
    }
    if (group.id === "ownedHorses") setIsOwnedHorsesOpen(true);
    if (group.id === "eventEntry") setIsEventEntryOpen(true);
    if (group.id === "myOrders") setIsMyOrdersOpen(true);
    if (group.id === "myProfile") setIsMyProfileOpen(true);
    setOpenCategory(null);
  };

  return (
    <>
      <ServiceFeedBack serviceId={serviceId} toast={toast} key={'feedBackForm'} setShowPopUp={setShowPopUp} showPopUp={showPopUp} />
      <div
        className={`page-overlay text-center ${ownerProfileLoading ||
          showEntryLoading ||
          auctionEntryLoading ||
          servicesRequestsLoading || showLoader
          ? "classdisplay"
          : "classnotdisplay"
          }`}
      >
        <div className="loaderDiv">
          <Loader />
        </div>
      </div>
      <ToastContainer
        position="top-right"
        onClick={dismissAll}
        theme="colored"
        autoClose={5000}
      />

      {userProfile?.status?.includes("Pending") && (
        <div style={{ display: "flex" }}>
          <div className="upgradeRequestFlage">
            {translate(`web.${userProfile?.status}`, userProfile?.status)}
            {" - "}
            {translate(
              `web.${convertToCamelCase(userProfile.upgradeStatus)}`,
              userProfile.upgradeStatus
            )}
          </div>
        </div>
      )}

      {
        <React.Fragment>
          <>
            <div className={serviceRequestHeadContainer}>

              {!!ownerDetailsData && (
                <React.Fragment>
                  <div className={serviceRequestTitle}>
                    <h2 className="fw-bold">
                      {!!ownerDetailsData.ownerId &&
                        ownerDetailsData.id == userProfile.id
                        ? ownerDetailsData.ownerId +
                        " - " +
                        (currentLanguage == "en"
                          ? userProfile.fullName
                          : userProfile.fullNameAr)
                        : !!ownerDetailsData.ownerId &&
                        ownerDetailsData.ownerId +
                        " - " +
                        ownerDetailsData.name}
                      {!!!ownerDetailsData.ownerId && (currentLanguage == "en"
                        ? userProfile.fullName
                        : userProfile.fullNameAr)}
                    </h2>
                    <div className="row mx-0">
                      <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 mb-1 horseCardDescription ps-0">
                        <i className="fa-solid fa-earth-americas C89C66"></i>
                        <span>
                          {ownerDetailsData.nationality}
                        </span>
                      </div>
                      {!!ownerDetailsData?.numberofHorsesOwned &&
                        ownerDetailsData?.numberofHorsesOwned > 0 && (
                          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 mb-1 horseCardDescription ps-0">
                            <i className="fa-solid fa-chess-knight C89C66" />
                            {translate("web.owns", "Owns")}{" "}
                            {ownerDetailsData.numberofHorsesOwned}{" "}
                            {translate("web.horses", "Horses")}
                          </div>
                        )}
                    </div>
                  </div>

                  <div className={userDropDown}>
                    {/* {!!subOwnerProfiles && subOwnerProfiles.length > 0 && false&& (
                      <React.Fragment>
                        <NetaqInput
                          type='select'
                          name='select account'
                          hideLable
                          listSelect={
                            [
                              ...(!!subOwnerProfiles &&
                                subOwnerProfiles.map((a) => ({
                                  label:
                                    normailizeOwnerName(a, currentLanguage),
                                  value: a.value,
                                }))),
                            ]

                          }
                          value={profile}
                          onChange={handleSelectAccountChange}
                          isSearchable
                          noOptionsMessage={() =>
                            translate("web.noOptions", "No Options")
                          }
                        />
                      </React.Fragment>
                    )} */}
                    <UserCentralDropDown onChange={handleSelectAccountChange} />
                  </div>
                  <div className="col-12 mb-main">
                    <hr className="dropdown-divider my-1" />
                  </div>
                </React.Fragment>
              )}
            </div>
          </>

          <div className="row rtl">
            {!!userProfile?.isProfileCompleted && (
              <>
                {/* Mobile Category Buttons with Floating Dropdowns (only on mobile screens < md) */}
                <div className="col-12 d-block d-md-none mb-3 rtl">
                  <div ref={mobileNavRef} className="profile-mobile-nav-wrapper" style={{ position: "relative", width: "100%" }}>
                    <div
                      className="profile-mobile-category-scroll-bar"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        overflowX: "auto",
                        scrollBehavior: "smooth",
                        padding: "4px 2px 10px 2px",
                        WebkitOverflowScrolling: "touch",
                        scrollbarWidth: "none",
                      }}
                      onScroll={() => {
                        if (openCategory) setOpenCategory(null);
                      }}
                    >
                      {mobileMenuGroups.map((group) => {
                        const isActive = isCategoryActive(group);
                        const isOpen = openCategory === group.id;
                        return (
                          <button
                            key={group.id}
                            ref={(el) => {
                              buttonRefs.current[group.id] = el;
                            }}
                            type="button"
                            className={`ownerProfileButton ${
                              isActive ? "active" : "inactive"
                            } ${isOpen ? "open" : ""}`}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "10px",
                              padding: "10px 20px",
                              borderRadius: "5px",
                              fontSize: "14px",
                              fontWeight: 600,
                              whiteSpace: "nowrap",
                              cursor: "pointer",
                              border: "none",
                              backgroundColor: isActive
                                ? "var(--mainGold)"
                                : "rgba(0, 0, 0, 0.08)",
                              color: isActive ? "#ffffff" : "#000000",
                              transition: "all 300ms",
                              flexShrink: 0,
                              outline: "none",
                              fontFamily: "inherit",
                              minWidth: "auto",
                            }}
                            onClick={() => handleCategoryClick(group)}
                            aria-expanded={isOpen}
                          >
                            <span>{group.title}</span>
                            {group.items.length > 1 && (
                              <i className={`fa fa-chevron-${isOpen ? "up" : "down"}`}></i>
                            )}
                          </button>
                        );
                      })}
                    </div>

                    {openGroup && (
                      <div
                        className="profile-floating-dropdown-menu"
                        style={{
                          ...dropdownStyle,
                          position: "absolute",
                          backgroundColor: "#ffffff",
                          borderRadius: "5px",
                          border: "1px solid rgba(0, 0, 0, 0.12)",
                          boxShadow:
                            "0 8px 24px rgba(0, 0, 0, 0.12)",
                          zIndex: 1050,
                          minWidth: "200px",
                          maxWidth: "280px",
                          padding: "4px 0",
                          WebkitOverflowScrolling: "touch",
                        }}
                      >
                        {openGroup.items.map((item, idx) => {
                          const isSelected = activeTab === item.key;
                          return (
                            <div
                              key={item.key}
                              className={`profile-floating-dropdown-item ${
                                isSelected ? "active" : ""
                              }`}
                              style={{
                                padding: "10px 16px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: "12px",
                                fontSize: "14px",
                                fontWeight: isSelected ? 700 : 500,
                                color: isSelected
                                  ? "var(--mainGold)"
                                  : "#000000",
                                backgroundColor: isSelected
                                  ? "rgba(228, 77, 82, 0.08)"
                                  : "transparent",
                                cursor: "pointer",
                                transition: "background-color 0.15s ease",
                                borderBottom:
                                  idx === openGroup.items.length - 1
                                    ? "none"
                                    : "1px solid #f0f0f0",
                                borderRight:
                                  isSelected && currentLanguage === "ar"
                                    ? "3px solid var(--mainGold)"
                                    : "none",
                                borderLeft:
                                  isSelected && currentLanguage !== "ar"
                                    ? "3px solid var(--mainGold)"
                                    : "none",
                              }}
                              onClick={() => handleMobileTabSelect(item, openGroup)}
                            >
                              <span>{item.label}</span>
                              {isSelected && (
                                <i
                                  className="fa fa-check"
                                  style={{ color: "var(--mainGold)", fontSize: "12px" }}
                                ></i>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>

                {/* Desktop Sidebar Accordion Menu (only on desktop screens >= md) */}
                <div className="col-lg-3 col-md-4 d-none d-md-block rtl">
                {/* 1. Owned Horses */}
                {hasOwnedHorsesPermission && (
                  <>
                    <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                      <span
                        className="ownerProfileButton"
                        style={{
                          background:
                            (activeTab === "allRegisteredHorses" ||
                              activeTab === "exported" ||
                              activeTab === "dead" ||
                              activeTab === "inactive")
                              ? "var(--mainGold)"
                              : "rgba(0,0,0,0.08)",
                          color:
                            (activeTab === "allRegisteredHorses" ||
                              activeTab === "exported" ||
                              activeTab === "dead" ||
                              activeTab === "inactive")
                              ? "#fff"
                              : "#000",
                          position: "relative",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={() => setIsOwnedHorsesOpen(!isOwnedHorsesOpen)}
                      >
                        {translate("web.ownedHorses", "Owned Horses")}
                        <i
                          className={`fa fa-chevron-${isOwnedHorsesOpen ? "up" : "down"}`}
                          style={{
                            position: "absolute",
                            right: currentLanguage === "ar" ? "auto" : "15px",
                            left: currentLanguage === "ar" ? "15px" : "auto",
                          }}
                        ></i>
                      </span>
                    </div>

                    {isOwnedHorsesOpen && (
                      <div
                        style={{
                          padding: "0 15px",
                        }}
                      >
                        <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                          <span
                            className="ownerProfileButton"
                            style={{
                              background:
                                activeTab === "allRegisteredHorses"
                                  ? "var(--mainGold)"
                                  : "rgba(0,0,0,0.04)",
                              color:
                                activeTab === "allRegisteredHorses" ? "#fff" : "#000",
                              fontSize: "14px",
                            }}
                            onClick={() => {
                              dispatch(emptyPage());
                              setActiveTab("allRegisteredHorses");
                              setActiveTabQuery("allRegisteredHorses");
                            }}
                          >
                            {translate(
                              "web.allRegisteredHorses",
                              "Registered Horses"
                            )}
                          </span>
                        </div>
                        <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                          <span
                            className="ownerProfileButton"
                            style={{
                              background:
                                activeTab === "exported"
                                  ? "var(--mainGold)"
                                  : "rgba(0,0,0,0.04)",
                              color: activeTab === "exported" ? "#fff" : "#000",
                              fontSize: "14px",
                            }}
                            onClick={() => {
                              dispatch(emptyPage());
                              setActiveTab("exported");
                              setActiveTabQuery("exported");
                            }}
                          >
                            {translate("web.exported", "Exported")}
                          </span>
                        </div>
                        <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                          <span
                            className="ownerProfileButton"
                            style={{
                              background:
                                activeTab === "dead"
                                  ? "var(--mainGold)"
                                  : "rgba(0,0,0,0.04)",
                              color: activeTab === "dead" ? "#fff" : "#000",
                              fontSize: "14px",
                            }}
                            onClick={() => {
                              dispatch(emptyPage());
                              setActiveTab("dead");
                              setActiveTabQuery("dead");
                            }}
                          >
                            {translate("web.dead", "Dead")}
                          </span>
                        </div>
                        <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                          <span
                            className="ownerProfileButton"
                            style={{
                              background:
                                activeTab === "inactive"
                                  ? "var(--mainGold)"
                                  : "rgba(0,0,0,0.04)",
                              color: activeTab === "inactive" ? "#fff" : "#000",
                              fontSize: "14px",
                            }}
                            onClick={() => {
                              dispatch(emptyPage());
                              setActiveTab("inactive");
                              setActiveTabQuery("inactive");
                            }}
                          >
                            {translate("web.inactive", "Inactive")}
                          </span>
                        </div>
                      </div>
                    )}
                  </>
                )}

                {/* 2. Event Entry */}
                {(hasShowEntryPermission ||
                  hasAuctionEntryPermission ||
                  hasParticipateHistoryPermission ||
                  hasWonHorsesPermission ||
                  showHandlerCompetition) && (
                  <>
                    <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                      <span
                        className="ownerProfileButton"
                        style={{
                          background:
                            (activeTab === "showEntry" ||
                              activeTab === "auctionEntry" ||
                              activeTab === "participateHistory" ||
                              activeTab === "wonhorses" ||
                              activeTab === "handlerShow")
                              ? "var(--mainGold)"
                              : "rgba(0,0,0,0.08)",
                          color:
                            (activeTab === "showEntry" ||
                              activeTab === "auctionEntry" ||
                              activeTab === "participateHistory" ||
                              activeTab === "wonhorses" ||
                              activeTab === "handlerShow")
                              ? "#fff"
                              : "#000",
                          position: "relative",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={() => setIsEventEntryOpen(!isEventEntryOpen)}
                      >
                        {translate("web.eventEntry", "Event Entry")}
                        <i
                          className={`fa fa-chevron-${isEventEntryOpen ? "up" : "down"}`}
                          style={{
                            position: "absolute",
                            right: currentLanguage === "ar" ? "auto" : "15px",
                            left: currentLanguage === "ar" ? "15px" : "auto",
                          }}
                        ></i>
                      </span>
                    </div>

                    {isEventEntryOpen && (
                      <div
                        style={{
                          padding: "0 15px",
                        }}
                      >
                        {hasShowEntryPermission && (
                          <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                            <span
                              className="ownerProfileButton"
                              style={{
                                background:
                                  activeTab === "showEntry"
                                    ? "var(--mainGold)"
                                    : "rgba(0,0,0,0.04)",
                                color: activeTab === "showEntry" ? "#fff" : "#000",
                                fontSize: "14px",
                              }}
                              onClick={() => {
                                dispatch(emptyPageShowEntry());
                                setActiveTab("showEntry");
                                setActiveTabQuery("showEntry");
                              }}
                            >
                              {translate("web.showEntry", "Show Entry")}
                            </span>
                          </div>
                        )}

                        {hasAuctionEntryPermission && (
                          <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                            <span
                              className="ownerProfileButton"
                              style={{
                                background:
                                  activeTab === "auctionEntry"
                                    ? "var(--mainGold)"
                                    : "rgba(0,0,0,0.04)",
                                color:
                                  activeTab === "auctionEntry" ? "#fff" : "#000",
                                fontSize: "14px",
                              }}
                              onClick={() => {
                                setActiveTab("auctionEntry");
                                setActiveTabQuery("auctionEntry");
                              }}
                            >
                              {translate("web.auctionEntry", "Auction Entry")}
                            </span>
                          </div>
                        )}

                        {hasParticipateHistoryPermission && (
                          <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                            <span
                              className="ownerProfileButton"
                              style={{
                                background:
                                  activeTab === "participateHistory"
                                    ? "var(--mainGold)"
                                    : "rgba(0,0,0,0.04)",
                                color:
                                  activeTab === "participateHistory"
                                    ? "#fff"
                                    : "#000",
                                fontSize: "14px",
                              }}
                              onClick={() => {
                                setActiveTab("participateHistory");
                                setActiveTabQuery("participateHistory");
                              }}
                            >
                              {translate(
                                "web.participateHistory",
                                "Participate History"
                              )}
                            </span>
                          </div>
                        )}

                        {hasWonHorsesPermission && (
                          <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                            <span
                              className="ownerProfileButton"
                              style={{
                                background:
                                  activeTab === "wonhorses"
                                    ? "var(--mainGold)"
                                    : "rgba(0,0,0,0.04)",
                                color: activeTab === "wonhorses" ? "#fff" : "#000",
                                fontSize: "14px",
                              }}
                              onClick={() => {
                                setActiveTab("wonhorses");
                                setActiveTabQuery("wonhorses");
                              }}
                            >
                              {translate(
                                "web.horsesAcquiredAtAuctions",
                                "Horses Acquired At Auctions"
                              )}
                            </span>
                          </div>
                        )}

                        {showHandlerCompetition && (
                          <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                            <span
                              className="ownerProfileButton"
                              style={{
                                background:
                                  activeTab === "handlerShow"
                                    ? "var(--mainGold)"
                                    : "rgba(0,0,0,0.04)",
                                color:
                                  activeTab === "handlerShow" ? "#fff" : "#000",
                                fontSize: "14px",
                              }}
                              onClick={() => {
                                setActiveTab("handlerShow");
                                setActiveTabQuery("handlerShow");
                              }}
                            >
                              {translate(
                                "web.emirateHandlerCompetition",
                                "Emirati Handler competition"
                              )}
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}

                {/* 3. My Orders */}
                {userProfile.accountType !== "Scoring" && userProfile.accountType !== "Organizer" && (
                  <>
                    <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                      <span
                        className="ownerProfileButton"
                        style={{
                          background:
                            (activeTab === "e_services" ||
                              activeTab === "semenRequests" ||
                              activeTab === "paymentHistory" ||
                              activeTab === "organizerRequests")
                              ? "var(--mainGold)"
                              : "rgba(0,0,0,0.08)",
                          color:
                            (activeTab === "e_services" ||
                              activeTab === "semenRequests" ||
                              activeTab === "paymentHistory" ||
                              activeTab === "organizerRequests")
                              ? "#fff"
                              : "#000",
                          position: "relative",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={() => setIsMyOrdersOpen(!isMyOrdersOpen)}
                      >
                        {translate("web.myOrders", "My Orders")}
                        <i
                          className={`fa fa-chevron-${isMyOrdersOpen ? "up" : "down"}`}
                          style={{
                            position: "absolute",
                            right: currentLanguage === "ar" ? "auto" : "15px",
                            left: currentLanguage === "ar" ? "15px" : "auto",
                          }}
                        ></i>
                      </span>
                    </div>

                    {isMyOrdersOpen && (
                      <div
                        style={{
                          padding: "0 15px",
                        }}
                      >
                        {userProfile.accountType !== "Organizer" && (
                          <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                            <span
                              className="ownerProfileButton"
                              style={{
                                background:
                                  activeTab === "e_services"
                                    ? "var(--mainGold)"
                                    : "rgba(0,0,0,0.04)",
                                color:
                                  activeTab === "e_services" ? "#fff" : "#000",
                                fontSize: "14px",
                              }}
                              onClick={() => {
                                setActiveTab("e_services");
                                setActiveTabQuery("e_services");
                              }}
                            >
                              {translate("web.servicesRequests", "Services Requests")}
                            </span>
                          </div>
                        )}

                        {isTestApp == "true" &&
                          userProfile.accountType !== "Organizer" && (
                            <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                              <span
                                className="ownerProfileButton"
                                style={{
                                  background:
                                    activeTab === "semenRequests"
                                      ? "var(--mainGold)"
                                      : "rgba(0,0,0,0.04)",
                                  color:
                                    activeTab === "semenRequests"
                                      ? "#fff"
                                      : "#000",
                                  fontSize: "14px",
                                }}
                                onClick={() => {
                                  setActiveTab("semenRequests");
                                  setActiveTabQuery("semenRequests");
                                }}
                              >
                                {translate("web.semenOrders", "Semen Orders")}
                              </span>
                            </div>
                          )}

                        {userProfile.accountType !== "Organizer" && (
                          <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                            <span
                              className="ownerProfileButton"
                              style={{
                                background:
                                  activeTab === "paymentHistory"
                                    ? "var(--mainGold)"
                                    : "rgba(0,0,0,0.04)",
                                color:
                                  activeTab === "paymentHistory"
                                    ? "#fff"
                                    : "#000",
                                fontSize: "14px",
                              }}
                              onClick={() => {
                                setActiveTab("paymentHistory");
                                setActiveTabQuery("paymentHistory");
                              }}
                            >
                              {translate("web.paymentHistory", "Payment History")}
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}


                        {userProfile.accountType === "Organizer" && (
                          <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                            <span
                              className="ownerProfileButton"
                              style={{
                                background:
                                  activeTab === "organizerRequests"
                                    ? "var(--mainGold)"
                                    : "rgba(0,0,0,0.04)",
                                color:
                                  activeTab === "organizerRequests"
                                    ? "#fff"
                                    : "#000",
                                fontSize: "14px",
                              }}
                              onClick={() => {
                                setActiveTab("organizerRequests");
                                setActiveTabQuery("organizerRequests");
                              }}
                            >
                              {translate(
                                "web.organizingRequests",
                                "Organizing Requests"
                              )}
                            </span>
                          </div>
                        )}

                {/* Scoring Account Tab */}
                {userProfile.accountType == "Scoring" && (
                  <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                    <span
                      className="ownerProfileButton"
                      style={{
                        background:
                          activeTab === "liveShowResult"
                            ? "var(--mainGold)"
                            : "rgba(0,0,0,0.08)",
                        color: activeTab === "liveShowResult" ? "#fff" : "#000",
                      }}
                      onClick={() => {
                        setActiveTab("liveShowResult");
                        setActiveTabQuery("liveShowResult");
                      }}
                    >
                      {translate("web.liveShowResult", "Live Show Result")}
                    </span>
                  </div>
                )}
                
                {/* 4. My Profile */}
                <>
                  <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                    <span
                      className="ownerProfileButton"
                      style={{
                        background:
                          (activeTab === "accountSetting" ||
                            activeTab === "teamsAccessPermissions")
                            ? "var(--mainGold)"
                            : "rgba(0,0,0,0.08)",
                        color:
                          (activeTab === "accountSetting" ||
                            activeTab === "teamsAccessPermissions")
                            ? "#fff"
                            : "#000",
                        position: "relative",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onClick={() => setIsMyProfileOpen(!isMyProfileOpen)}
                    >
                      {translate("web.myProfile", "My Profile")}
                      <i
                        className={`fa fa-chevron-${isMyProfileOpen ? "up" : "down"}`}
                        style={{
                          position: "absolute",
                          right: currentLanguage === "ar" ? "auto" : "15px",
                          left: currentLanguage === "ar" ? "15px" : "auto",
                        }}
                      ></i>
                    </span>
                  </div>

                  {isMyProfileOpen && (
                    <div
                      style={{
                        padding: "0 15px",
                      }}
                    >
                      <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                        <span
                          className="ownerProfileButton"
                          style={{
                            background:
                              activeTab === "accountSetting"
                                ? "var(--mainGold)"
                                : "rgba(0,0,0,0.04)",
                            color:
                              activeTab === "accountSetting" ? "#fff" : "#000",
                            fontSize: "14px",
                          }}
                          onClick={() => {
                            setActiveTab("accountSetting");
                            setActiveTabQuery("accountSetting");
                          }}
                        >
                          {translate("web.profileDetails", "Profile Details")}
                        </span>
                      </div>

                      {isLoggedInUser && (
                        <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                          <span
                            className="ownerProfileButton"
                            style={{
                              background:
                                activeTab === "teamsAccessPermissions"
                                  ? "var(--mainGold)"
                                  : "rgba(0,0,0,0.04)",
                              color:
                                activeTab === "teamsAccessPermissions"
                                  ? "#fff"
                                  : "#000",
                              fontSize: "14px",
                            }}
                            onClick={() => {
                              setActiveTab("teamsAccessPermissions");
                              setActiveTabQuery("teamsAccessPermissions");
                            }}
                          >
                            {translate(
                              "web.teamsAccessPermissions",
                              "Teams Access Permissions"
                            )}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                </>
                {/* {userProfile.accountType == "BasicAccount" && (
                <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                  <span
                    className="ownerProfileButton"
                    style={{
                      background:
                        activeTab === "upgradeProfile"
                          ? "var(--mainGold)"
                          : "rgba(0,0,0,0.08)",
                      color: activeTab === "upgradeProfile" ? "#fff" : "#000",
                    }}
                    onClick={() => {
                      setActiveTab("upgradeProfile");
                      setActiveTabQuery("upgradeProfile");
                    }}
                  >
                    {translate("web.upgradeProfile", "Upgrade Profile")}
                  </span>
                </div>
              )} */}
                {/* {userProfile.accountType == "Agent" && (
                <div className="col-lg-12 col-md-5 col-sm-5 mb-2">
                  <span
                    className="ownerProfileButton"
                    style={{
                      background:
                        activeTab === "owenerPermisions"
                          ? "var(--mainGold)"
                          : "rgba(0,0,0,0.08)",
                      color: activeTab === "owenerPermisions" ? "#fff" : "#000",
                    }}
                    onClick={() => {
                      setActiveTab("owenerPermisions");
                      setActiveTabQuery("owenerPermisions");
                    }}
                  >
                    {translate("web.owenerPermisions", "Owener Permisions")}
                  </span>
                </div>
              )} */}
                </div>
              </>
            )}
            {/* Horse Cards (First Four Tabs) */}
            {(activeTab === "allRegisteredHorses" ||
              activeTab === "exported" ||
              activeTab === "dead" ||
              activeTab === "inactive") && (
                <div className="col-lg-9 col-md-8 col-sm-12  rtl">
                  <div className="row rtl" >
                    <div className="col-sm-6 col-12">
                      <SearchBox
                        isForm={false}
                        value={searchValue}
                        selectedOption={selectedSearchType}
                        isWithSubmitBTN={true}
                        onSubmitBtnFunction={handelSearch}
                        onChange={handleChange}
                        isFullWidth
                        showMoreFilter={false}
                        placeholder={translate('web.search', 'search')}
                        resultCount={totalCountOwnerHorses}
                        optionsList={[
                          { value: "2", label: translate("web.highestRegNum", "Highest Reg Num") },
                          { value: "1", label: translate("web.lowestRegNum", "Lowest Reg Num") },
                          { value: "3", label: translate("web.atoz", "A-Z") },
                          { value: "4", label: translate("web.ztoa", "Z-A") },
                          { value: "5", label: translate("web.highestAge", "Highest Age") },
                          { value: "6", label: translate("web.ageLowest", "Age Lowest") }
                        ]}
                        onOptionSelect={handleSelectedSearchType}
                      />
                    </div>
                    {/* <CustomSecondPopUp
                      trigger={<div className="col-sm-6 col-12 text-end">
                        <NewActionButton
                          classNames={`btn-danger w-unset mx-auto`}
                          text={translate('web.horsesAbove30', 'Horses Above 30')}
                        />
                      </div>}
                      title={translate('web.horsesAbove30', 'Horses Above 30')}
                      children={}
                    /> */}
                    <div className="col-sm-6 col-12 text-end">
                      <NewActionButton
                        classNames={`btn-danger w-unset mx-auto`}
                        text={translate('web.horsesAbove30', 'Horses Above 30')}
                        onClick={(e) => setShowHorsesPop(true)}
                      />
                    </div>
                    {showHorsesPop &&
                      <OldHorsesDialog showNow={true} key={'OldHorsesDialog'} setShowHorsesPop={setShowHorsesPop} toast={toast} />
                    }

                  </div>



                  <div className="row rtl">
                    {!!ownerHorsesData &&
                      ownerHorsesData.length > 0 &&
                      ownerHorsesData.map((item, i) => (
                        <HorseCard
                          isProfilePage={true}
                          isArabicClass={true}
                          item={item}
                          i={i}
                          showDownloadPassport={
                            activeTab === "allRegisteredHorses"
                          }
                        />
                      ))}
                    <div
                      className="col-lg-12 col-md-12 col-sm-12  text-center row"
                    >
                      <div className="mx-auto w-unset ">
                        {!ownerProfileLoading &&
                          !!ownerHorsesData &&
                          ownerHorsesData.length > 0 ? (
                          <NewActionButton
                            disabled={stateShowMoreButtonHorse}
                            onClick={handelShowMore}
                            text={`
                        ${translate("web.showMore", "Show More")} (${ownerHorsesData.length
                              } ${translate(
                                "web.of",
                                "of"
                              )} ${totalCountOwnerHorses})`}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}


            {/* Account Setting Tab */}
            {activeTab === "accountSetting" && (
              <AccountSetting
                translate={translate}
                cachedUserProfile={cachedUserProfile}
                englishName={englishName}
                ownerAppuserByIdData={ownerAppuserByIdData}
                setEnglishName={setEnglishName}
                arabicName={arabicName}
                setArabicName={setArabicName}
                email={email}
                userIsUAEPass={userIsUAEPass}
                setEmail={setEmail}
                phoneNo={phoneNo}
                setPhoneNo={setPhoneNo}
                setIsAgent={setIsAgent}
                setIsHandler={setIsHandler}
                isAgent={isAgent}
                isHandler={isHandler}
                userProfile={userProfile}
                secondEmail={secondEmail}
                setSecondEmail={setSecondEmail}
                ownerPhoneNo={ownerPhoneNo}
                setOwnerPhoneNo={setOwnerPhoneNo}
                mobileNo={mobileNo}
                setMobileNo={setMobileNo}
                buttonSubmitStyle={buttonSubmitStyle}
                handleMouseOver={handleMouseOver}
                handleMouseOut={handleMouseOut}
                setImageURL={setImageURL}
                buttonclearStyle={buttonclearStyle}
                buttoncloseStyle={buttoncloseStyle}
                handleFileChange={handleFileChange}
                imageURL={imageURL}
                handelUpdateOwnerAppuserAccount={handelUpdateOwnerAppuserAccount}
                handelChangePassword={handelChangePassword}
                setOldPassword={setOldPassword}
                showErrorConfirmPassword={showErrorConfirmPassword}
                setConfirmNewPassword={setConfirmNewPassword}
                setConfirmPassword={setConfirmPassword}
                bankName={bankName}
                setBankName={setBankName}
                iban={iban}
                setIban={setIban}
                swiftCode={swiftCode}
                setSwiftCode={setSwiftCode}
                bneficiaryName={bneficiaryName}
                setBneficiaryName={setBneficiaryName}
                bankCountry={bankCountry}
                setBankCountry={setBankCountry}
                curency={curency}
                setCurency={setCurency}
                bankAccountNumber={bankAccountNumber}
                setBankAccountNumber={setBankAccountNumber}
                uploadedHandlerCertificate={uploadedHandlerCertificate}
                setUploadedHandlerCertificate={setUploadedHandlerCertificate}
                handleHandlerCertificateUploaded={handleHandlerCertificateUploaded}
                uploadedNationalIdFile={uploadedNationalIdFile}
                setUploadedNationalIdFile={setUploadedNationalIdFile}
                handleNationalIdFileUploaded={handleNationalIdFileUploaded}
                reloadProfile={loadDataFromLocal}
                setActiveTab={setActiveTab}
                profileImageFile={profileImageFile}
                setProfileImageFile={setProfileImageFile}
                handleProfileImageFileUploaded={handleProfileImageFileUploaded}
                hasTrn={hasTrn}
                setHasTrn={setHasTrn}
                setTrc={setTrcFile}
                setTrn={setTrn}
                trc={trcFile}
                trn={trn}
                toast={toast}
                key={'account setting'}
              />
            )}
            {/* horse Market */}
            {/* {activeTab === "horseMarket" && (
              <div className="col-lg-9 col-md-8 col-sm-12 row rtl ">
                {!addNewHorse && (
                  <div className="col-lg-12 col-sm-12">
                    <span
                      className="AddNewHorseBtn"
                      onClick={() => setAddNewHorse(true)}
                    >
                      + {translate("web.addNewHorse", "Add New Horse")}
                    </span>
                  </div>
                )}
                {!addNewHorse && (
                  <React.Fragment>
                    {!!ownerHorseMarketData &&
                      ownerHorseMarketData.length > 0 &&
                      ownerHorseMarketData.map((item, i) => (
                        <div
                          className="col-lg-6 col-md-12 col-sm-12 "
                          style={{
                            padding: 0,
                            paddingRight: 5,
                            background: "#FCFAF7",
                            marginTop: 10,
                          }}
                          key={i}
                        >
                          <div
                            className="horseCardContainer row rtl"
                            style={{ display: "flex" }}
                          >
                            <div className="col-lg-4 col-md-4 col-sm-12 horse-market-card-div  ">
                              <span className="horseMarketCardCategory">
                                {item.horseCategory != null
                                  ? item.horseCategory === "ShowHorse"
                                    ? translate("web.showHorse", "show Horse")
                                    : item.horseCategory === "FlatRace"
                                      ? translate("web.flatRace", "Flat Race")
                                      : item.horseCategory === "EnduranceHorse"
                                        ? translate(
                                          "web.enduranceHorse",
                                          "Endurance Horse"
                                        )
                                        : item.horseCategory
                                  : item.horseCategory}
                              </span>
                              <div className="horseMarketImageContainer_OwnerProfile">
                                <img
                                  style={{ borderRadius: 5 }}
                                  src={
                                    item.horseMarketMedia.length > 0
                                      ? item.horseMarketMedia[0].url
                                      : `${BaseURL}/assets/img/horsemarket.jpg`
                                  }
                                  alt="horsemarket"
                                />
                              </div>
                            </div>
                            <div className="col-lg-8 col-md-8 col-sm-12  ">
                              <span className="horseMarketCardLabeltitle">
                                {currentLanguage === "en" ? (
                                  item.englisName !== null &&
                                    item.englisName !== "" ? (
                                    item.englisName
                                  ) : (
                                    <React.Fragment> &nbsp;</React.Fragment>
                                  )
                                ) : item.arabicName !== null &&
                                  item.arabicName !== "" ? (
                                  item.arabicName
                                ) : (
                                  <React.Fragment> &nbsp;</React.Fragment>
                                )}
                              </span>
                              <span
                                className="horseMarketCardLabeltitle rtlabs"
                                style={{
                                  position: "absolute",
                                  right: 10,
                                  cursor: "pointer",
                                }}
                                onClick={(e) => handelUpdateHorseMarket(item)}
                              >
                                <img
                                  alt="editicon"
                                  src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgY2xhc3M9ImZlYXRoZXIgZmVhdGhlci1lZGl0IiBmaWxsPSJub25lIiBoZWlnaHQ9IjI0IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xMSA0SDRhMiAyIDAgMCAwLTIgMnYxNGEyIDIgMCAwIDAgMiAyaDE0YTIgMiAwIDAgMCAyLTJ2LTciLz48cGF0aCBkPSJNMTguNSAyLjVhMi4xMjEgMi4xMjEgMCAwIDEgMyAzTDEyIDE1bC00IDEgMS00IDkuNS05LjV6Ii8+PC9zdmc+"
                                />
                              </span>
                              <div className="row ">
                                <div
                                  className="col-md-12"
                                  style={{
                                    marginBottom: 5,
                                  }}
                                >
                                  <span className="horseCardlabelContent ">
                                    {item.birthDate &&
                                      formatDate(item.birthDate)}{" "}
                                    - {item.genderString}
                                    {(item.birthDate === null ||
                                      item.birthDate === "") && (
                                        <React.Fragment> &nbsp;</React.Fragment>
                                      )}
                                  </span>
                                  <span className="horseCardlabelContent ">
                                    {currentLanguage === "en" ? (
                                      item.originEn !== null &&
                                        item.originEn !== "" ? (
                                        item.originEn + "," + item.cityName
                                      ) : (
                                        <React.Fragment> &nbsp;</React.Fragment>
                                      )
                                    ) : item.originAr !== null &&
                                      item.originAr !== "" ? (
                                      item.originAr + "," + item.cityNameAr
                                    ) : (
                                      <React.Fragment> &nbsp;</React.Fragment>
                                    )}
                                  </span>
                                  <div className="row">
                                    <div className="col-sm-2 cardKeyColor ">
                                      {translate("web.sire", "Sire")}
                                    </div>
                                    <div className="col-sm-10 cardValueColor ">
                                      {currentLanguage === "en"
                                        ? item.sireNameEn
                                        : item.sireNameAr}
                                    </div>
                                    <div className="col-sm-2 cardKeyColor ">
                                      {translate("web.dam", "dam")}
                                    </div>
                                    <div className="col-sm-10 cardValueColor ">
                                      {currentLanguage === "en"
                                        ? item.damNameEn
                                        : item.damNameAr}
                                    </div>
                                    <div className="col-sm-3 cardKeyColor ">
                                      {translate("web.color", "color")}
                                    </div>
                                    <div className="col-sm-9 cardValueColor ">
                                      {currentLanguage === "en"
                                        ? item.colorEn
                                        : item.colorAr}
                                    </div>
                                  </div>
                                  <span className="horseCardLabeltitle ">
                                    {item.horsePrice}{" "}
                                    {currentLanguage === "en" ? "AED" : "د.إ"}
                                  </span>
                                </div>
                              </div>

                              <div className="row">
                                <Link
                                  to={`/horsedetails?horseId=${item.id}&title=${encodeURIComponent(item.englisName || item.arabicName || '')}`}
                                  className="hoveronspan ViewProfileLink floatLeftinArabic rtl"
                                >
                                  {translate("web.viewDetails", "View Details")}
                                  <i className=" fa-solid fa-chevron-right justRotate red-fz-8-op-25"></i>
                                  <i className=" fa-solid fa-chevron-right justRotate red-fz-8-op-50"></i>
                                  <i className=" fa-solid fa-chevron-right justRotate red-fz-8-op-1"></i>
                                </Link>

                                <Link
                                  className="hoveronlink ViewProfileLink rtlabs text-end"
                                  style={{
                                    position: "absolute",
                                    bottom: 20,
                                    right: 10,
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    let confirmText = window.confirm(
                                      translate("web.confirmMsg", "Confirm Msg")
                                    );
                                    if (confirmText) {
                                      dispatch(
                                        FetchDeleteHorseMarketthunk(item.id)
                                      );
                                    } else {
                                      return false;
                                    }
                                  }}
                                >
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M5.05063 8.73418C4.20573 7.60763 5.00954 6 6.41772 6H17.5823C18.9905 6 19.7943 7.60763 18.9494 8.73418V8.73418C18.3331 9.55584 18 10.5552 18 11.5823V18C18 20.2091 16.2091 22 14 22H10C7.79086 22 6 20.2091 6 18V11.5823C6 10.5552 5.66688 9.55584 5.05063 8.73418V8.73418Z"
                                      stroke="#717171"
                                      strokeWidth="1.5"
                                    />
                                    <path
                                      d="M14 17L14 11"
                                      stroke="#717171"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M10 17L10 11"
                                      stroke="#717171"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M16 6L15.4558 4.36754C15.1836 3.55086 14.4193 3 13.5585 3H10.4415C9.58066 3 8.81638 3.55086 8.54415 4.36754L8 6"
                                      stroke="#717171"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                    />
                                  </svg>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}

                    <div
                      className="col-lg-12 col-md-12 col-sm-12 text-center"
                      style={{ marginTop: 20 }}
                    ></div>
                  </React.Fragment>
                )}
                {addNewHorse && (
                  <div className="col-lg-12 col-md-12 col-sm-6">
                    <div
                      className="row"
                      style={{
                        border: "1px solid #C89C66",
                        borderRadius: 5,
                        padding: 20,
                      }}
                    >
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <label
                          className="capatalize_text"
                        >
                          {translate(
                            "web.registerationNumber",
                            "Registeration Number"
                          )}
                        </label>
                        <span className="requiredColor">*</span>
                        {
                          <Select
                            options={[
                              {
                                label: translate(
                                  "web.registerationNumber",
                                  "Registeration Number"
                                ),
                                value: "",
                              },
                              ...(!!ownerHorsesDropDownData &&
                                ownerHorsesDropDownData
                              
                                  .map((a) => ({
                                    label: a.registerNumber + " - " + a.name,
                                    value: a.registerNumber,
                                  }))),
                            ]}
                            value={newHorseModel.selectDrop}
                            onChange={(e) => handleNewHorseChange(e, "regNo")}
                            placeholder={translate(
                              "web.registerationNumber",
                              "Registeration Number"
                            )}
                            name={"registerationNumber"}
                            isDisabled={newHorseModel.id !== ""}
                            isSearchable
                            //isClearable
                            noOptionsMessage={() =>
                              translate("web.noOptions", "No Options")
                            }
                            autoFocus={newHorseModel.id === ""}
                          />
                        }
                       
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <NetaqInput
                          type={"text"}
                          name={"arabicName"}
                          placeholder={translate(
                            "web.arabicName",
                            "Arabic Name"
                          )}
                          label={translate("web.arabicName", "Arabic Name")}
                          disabled={true}
                          value={newHorseModel.nameAr}
                        />
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <NetaqInput
                          type={"text"}
                          name={"englishName"}
                          placeholder={translate(
                            "web.englishName",
                            "English Name"
                          )}
                          label={translate("web.englishName", "English Name")}
                          disabled={true}
                          value={newHorseModel.nameEn}
                        />
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <NetaqInput
                          type={"text"}
                          name={"address"}
                          placeholder={translate("web.address", "Address")}
                          label={translate("web.address", "Address")}
                          disabled={true}
                          value={newHorseModel.address}
                        />
                      </div>

                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <NetaqInput
                          htmlTags={<span className="requiredColor">*</span>}
                          type={"select"}
                          value={newHorseModel.categoryDrop}
                          listSelect={[
                            {
                              text: translate("web.showHorse", "Show Horse"),
                              value: 1,
                            },
                            {
                              text: translate("web.flatRace", "Flat Race"),
                              value: 2,
                            },
                            {
                              text: translate(
                                "web.enduranceHorse",
                                "Endurance Horse"
                              ),
                              value: 3,
                            },
                          ]}
                          name={"category"}
                          placeholder={translate("web.category", "Category")}
                          label={translate("web.category", "Category")}
                          onChange={(e) => handleNewHorseChange(e, "category")}
                        />
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <NetaqInput
                          htmlTags={<span className="requiredColor">*</span>}
                          type={"select"}
                          value={newHorseModel.typeDrop}
                          listSelect={[
                            {
                              text: translate(
                                "web.horseMarket",
                                "Horse Market"
                              ),
                              value: "HorseMarket",
                            },
                            {
                              text: translate(
                                "web.horseCharity",
                                "Horse Charity"
                              ),
                              value: "HorseCharity",
                            },
                            {
                              text: translate(
                                "web.semenMarket",
                                "Semen Market"
                              ),
                              value: "SemenMarket",
                            },
                          ]}
                          name={"type"}
                          placeholder={translate("web.type", "type")}
                          label={translate("web.type", "type")}
                          onChange={(e) => handleNewHorseChange(e, "type")}
                        />
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <NetaqInput
                          htmlTags={<span className="requiredColor">*</span>}
                          type={"number"}
                          name={"horsePrice"}
                          placeholder={translate(
                            "web.priceInAED",
                            "Price In AED"
                          )}
                          label={translate("web.price", "Price")}
                          onChange={(e) => handleNewHorseChange(e, "price")}
                          value={newHorseModel.price}
                        />
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <NetaqInput
                          htmlTags={<span className="requiredColor">*</span>}
                          type={"select"}
                          value={newHorseModel.cityDrop}
                          listSelect={
                            !!citiesData &&
                            citiesData.map((a) => ({
                              text:
                                currentLanguage === "en" ? a.name : a.nameAr,
                              value: a.id,
                            }))
                          }
                          name={"city"}
                          placeholder={translate("web.emirate", "Emirate")}
                          label={translate("web.emirate", "Emirate")}
                          onChange={(e) => handleNewHorseChange(e, "city")}
                        />
                      </div>

                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <NetaqInput
                          htmlTags={<span className="requiredColor">*</span>}
                          type={"text"}
                          name={"phone"}
                          placeholder={translate("web.phone", "Phone")}
                          label={translate("web.phone", "Phone")}
                          onChange={(e) => handleNewHorseChange(e, "phone")}
                          value={newHorseModel.phone}
                        // value={
                        //   newHorseModel.phone !== ""
                        //     ? newHorseModel.phone
                        //     : userProfile?.phone
                        // }
                        />
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <NetaqInput
                          htmlTags={<span className="requiredColor">*</span>}
                          type={"email"}
                          name={"email"}
                          placeholder={translate("web.email", "Email")}
                          label={translate("web.email", "Email")}
                          onChange={(e) => handleNewHorseChange(e, "email")}
                          value={newHorseModel.email}
                        // value={
                        //   newHorseModel.email !== ""
                        //     ? newHorseModel.email
                        //     : userProfile?.email
                        // }
                        />
                        <span className={`text-danger ${emailNotValidMsg}`}>
                          {translate("web.emailNotValid", "Email not valid")}
                        </span>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <NetaqInput
                          //htmlTags={<span className="requiredColor">*</span>}
                          type={"text"}
                          name={"urlVideo"}
                          placeholder={translate("web.urlVideo", "URL Video")}
                          label={translate("web.urlVideo", "URL Video")}
                          onChange={(e) => handleNewHorseChange(e, "urlVideo")}
                          value={newHorseModel.urlVideo}
                        />
                        <span className={`text-danger ${urlVideoNotValidMsg}`}>
                          {translate("web.urlNotValid", "URL not valid")}
                        </span>
                      </div>

                      {newHorseModel.id !== "" && (
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <NetaqInput
                            name={"isSold"}
                            type={"checkbox"}
                            checked={newHorseModel.isSold}
                            label={translate("web.isSold", "isSold")}
                            onChange={(e) => handleNewHorseChange(e, "isSold")}
                          />
                        </div>
                      )}
                    </div>
                    <br />
                    <div
                      className="col-lg-12 col-md-12 col-sm-12"
                      style={{ padding: 0 }}
                    >
                      <FileUpload
                        multiple={true}
                        onFilesUploaded={setFiles}
                        emptyFiles={emptyFiles}
                        setEmptyFiles={setEmptyFiles}
                        urlImages={urlImages}
                        setUrlImages={setUrlImages}
                      />
                    </div>
                    <div className="submitButtonContainerleft">
                      
                      <ActionButton
                        type={"btn"}
                        label={translate("web.cancel", "Cancel")}
                        onClick={() => {
                          setAddNewHorse(false);
                          handleHorseMarketReset();
                          dispatch(
                            FetchOwnerHorseMarketthunk(
                              //"3a5f8ec0-c888-4b2b-4c0c-08dc12faba88"
                              localStorage.getItem("currentSubAccountId")
                            )
                          );
                        }}
                        text={translate("web.cancel", "Cancel")}
                        margin={"0"}
                      />
                      <ActionButton
                        type={"submit"}
                        label={translate("web.save", "Save")}
                        text={translate("web.save", "Save")}
                        margin={"0"}
                        onClick={handelNewHorse}
                        disabled={
                          newHorseModel.regNo !== "" &&
                            newHorseModel.horseId !== "" &&
                            newHorseModel.category !== "" &&
                            newHorseModel.type !== "" &&
                            newHorseModel.price !== "" &&
                            newHorseModel.city !== "" &&
                            newHorseModel.phone !== "" &&
                            newHorseModel.email !== "" &&
                            //newHorseModel.urlVideo !== "" &&
                            ((newHorseModel.id === "" && files.length > 0) ||
                              (newHorseModel.id !== "" &&
                                (files.length > 0 || urlImages.length > 0)))
                            ? false
                            : true
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
            )} */}

            {activeTab === "showEntry" && (
              <>
                <div className="col-lg-9 col-md-9 col-sm-12  rtl">
                  <div className="row rtl mb-main" >
                    <div className="col-sm-6 col-12">
                      <SearchBox
                        isFullWidth
                        onChange={(e) => {
                          setSearchShow(e.target.value);
                        }}
                        placeholder={translate(
                          "web.searchShow",
                          "Search By Show Name"
                        )}
                      />
                    </div>
                  </div>
                  {!!showEntryData && showEntryData.length > 0
                    ? upcomingEvents.length > 0 ? <><div className="row  ">
                      <h3 className="col-lg-6 col-md-6 col-sm-12 bold rtl">{translate('web.participateNow', 'Participate Now')}</h3>
                    </div>
                    </> : '' : ''}
                  <div className="row">
                    {!!showEntryData && showEntryData.length > 0
                      ? upcomingEvents.map((item, i) => (
                        <ShowEntryCard i={i} item={item} translate={translate} currentLanguage={currentLanguage} />
                      )) : ''}
                  </div>
                  {!!showEntryData && showEntryData.length > 0
                    ? showEntryData
                      .filter((item) => {
                        if (searchShow === "") {
                          return item;
                        } else if (searchShow !== "") {
                          return item.showName
                            .toLowerCase()
                            .includes(searchShow.toLowerCase());
                        }
                      }).filter((item) => !upcomingEvents.some(event => event === item))
                      .length > 0 && upcomingEvents.length > 0 ? <><div className="row  ">
                        <h3 className="col-lg-6 col-md-6 col-sm-12 bold rtl">{translate('web.other', 'Other')}</h3>
                      </div>
                    </> : '' : ''}
                  <div className="row">
                    {!!showEntryData && showEntryData.length > 0
                      ? showEntryData
                        .filter((item) => {
                          if (searchShow === "") {
                            return item;
                          } else if (searchShow !== "") {
                            return item.showName
                              .toLowerCase()
                              .includes(searchShow.toLowerCase());
                          }
                        }).filter((item) => !upcomingEvents.some(event => event === item))
                        // .filter((show) => (new Date(show.registerEndDate) < new Date()) || (new Date(show.registerStartDate) > new Date()))
                        .map((item, i) => (
                          <ShowEntryCard i={i} item={item} translate={translate} currentLanguage={currentLanguage} />
                        ))
                      : " "}
                  </div>
                  {totalCountShowEntry > pageShowEntry * takeShowEntry && (
                    <div className="row justify-content-center rtl mt-2">
                      <div className="col-lg-6 col-md-6 col-sm-6 text-center">
                        <ActionButton
                          type={"loadmore"}
                          label={translate("web.loadMore", "Load More")}
                          onClick={() => {
                            dispatch(incrementPageShowEntry());
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}

            {activeTab === "auctionEntry" && (
              <AuctionEntryList />
            )}
            {activeTab === "handlerShow" && (
              <HandlerShowList toast={toast} />
            )}
            {activeTab === "semenRequests" && (
              <div className="col-lg-9 col-md-8 col-sm-12 rtl">
                <SemenRequestsPage toast={toast} />
              </div>
            )}
            {activeTab === "e_services" && (
              <AllServicesRequestsPage />
            )}
            {activeTab === "paymentHistory" && (
              <div className="col-lg-9 col-md-8 col-sm-12">
                <PaymentHistory />
              </div>
            )}
            {activeTab === "participateHistory" && (
              <div className="col-lg-9 col-md-8 col-sm-12">
                <ParticipateHistory toast={toast} />
              </div>
            )}
            {activeTab === "wonhorses" && (
              <div className="col-lg-9 col-md-8 col-sm-12">
                <WonHorses toast={toast} />
              </div>
            )}
            {activeTab === "organizerRequests" && (
              <div className="col-lg-9 col-md-8 col-sm-12">
                <OrginizingRequests />
              </div>
            )}
            {activeTab === "upgradeProfile" &&
              userProfile.accountType == "BasicAccount" && (
                <div className="col-lg-9 col-md-8 col-sm-12">
                  <UpgradeProfile
                    toast={toast}
                    reloadProfile={loadDataFromLocal}
                    setActiveTab={setActiveTab}
                  />
                </div>
              )}
            {/* {activeTab === "owenerPermisions" &&
              userProfile.accountType == "Agent" && (
                <div className="col-lg-9 col-md-8 col-sm-12">
                  <OwnerPermisions
                    toast={toast}
                    reloadProfile={loadDataFromLocal}
                    setActiveTab={setActiveTab}
                  />
                </div>
              )} */}
            {activeTab == 'teamsAccessPermissions' &&
              <div className="col-lg-9 col-md-8 col-sm-12">
                <AccessPermisions profile={profile} key={'teamsAccessPermissions'} />
              </div>
            }
            {activeTab === "liveShowResult" &&
              (
                <div className="col-lg-9 col-md-8 col-sm-12">
                  <ScoringTab />
                </div>
              )}
          </div>
          <OldHorsesDialog key={'OldHorsesDialog'} toast={toast} />
        </React.Fragment>
      }
    </>
  );
}

